import * as React from 'react';

const BgBlurboxPattern = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 361 201"
    fill="none">
    <mask
      id="bgBlurboxPatternMask"
      width={361}
      height={201}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}>
      <path
        fill="#D9D9D9"
        d="M354.488.8h-348a6 6 0 0 0-6 6v188.001a6 6 0 0 0 6 6h348a6 6 0 0 0 6-6v-188a6 6 0 0 0-6-6Z"
      />
    </mask>
    <g mask="url(#bgBlurboxPatternMask)">
      <path
        fill="url(#bgBlurboxPatternColor1)"
        fillOpacity={0.1}
        d="M392.932 56.582h-40.497c-5.722 0-10.36 4.638-10.36 10.36v40.497c0 5.722 4.638 10.36 10.36 10.36h40.497c5.722 0 10.36-4.638 10.36-10.36V66.942c0-5.722-4.638-10.36-10.36-10.36Z"
      />
      <path
        fill="url(#bgBlurboxPatternColor2)"
        fillOpacity={0.22}
        d="M385.868 96.61h-78.169c-5.722 0-10.36 4.638-10.36 10.359v78.17c0 5.721 4.638 10.359 10.36 10.359h78.169c5.722 0 10.36-4.638 10.36-10.359v-78.17c0-5.721-4.638-10.36-10.36-10.36Z"
      />
      <path
        fill="url(#bgBlurboxPatternColor3)"
        fillOpacity={0.22}
        d="M124.519 142.52h-47.56c-5.722 0-10.36 4.638-10.36 10.36v47.561c0 5.721 4.638 10.359 10.36 10.359h47.56c5.722 0 10.36-4.638 10.36-10.359V152.88c0-5.722-4.638-10.36-10.36-10.36Z"
      />
      <path
        fill="url(#bgBlurboxPatternColor4)"
        fillOpacity={0.22}
        d="M134.88 46.221v-47.56c0-5.722-4.638-10.36-10.36-10.36H76.96c-5.722 0-10.36 4.638-10.36 10.36v47.56c0 5.722 4.638 10.36 10.36 10.36h47.56c5.722 0 10.36-4.638 10.36-10.36Z"
      />
      <path
        fill="url(#bgBlurboxPatternColor5)"
        fillOpacity={0.14}
        d="M-46.652 87.188h78.17c5.72 0 10.359-4.639 10.359-10.36v-78.17c0-5.721-4.638-10.36-10.36-10.36h-78.17c-5.72 0-10.359 4.639-10.359 10.36v78.17c0 5.721 4.638 10.36 10.36 10.36Z"
      />
      <path
        fill="url(#bgBlurboxPatternColor6)"
        fillOpacity={0.14}
        d="M286.98-11.7h-35.788c-5.722 0-10.36 4.639-10.36 10.36V34.45c0 5.721 4.638 10.36 10.36 10.36h35.788c5.722 0 10.36-4.639 10.36-10.36V-1.34c0-5.722-4.638-10.36-10.36-10.36Z"
      />
      <path
        fill="url(#bgBlurboxPatternColor7)"
        fillOpacity={0.14}
        d="M88.967 181.603v-78.169c0-5.722-4.638-10.36-10.36-10.36H.437c-5.72 0-10.36 4.638-10.36 10.36v78.169c0 5.722 4.64 10.36 10.36 10.36h78.17c5.722 0 10.36-4.638 10.36-10.36Z"
      />
    </g>
    <defs>
      <linearGradient
        id="bgBlurboxPatternColor1"
        x1={372.684}
        x2={386.222}
        y1={56.582}
        y2={120.153}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#999" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="bgBlurboxPatternColor2"
        x1={346.783}
        x2={368.653}
        y1={96.609}
        y2={199.302}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#999" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="bgBlurboxPatternColor3"
        x1={100.739}
        x2={115.839}
        y1={142.52}
        y2={213.426}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#999" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="bgBlurboxPatternColor4"
        x1={134.88}
        x2={63.973}
        y1={22.441}
        y2={37.542}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#999" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="bgBlurboxPatternColor5"
        x1={-7.567}
        x2={-29.437}
        y1={87.188}
        y2={-15.505}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#999" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="bgBlurboxPatternColor6"
        x1={269.086}
        x2={281.583}
        y1={-11.699}
        y2={46.982}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#999" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="bgBlurboxPatternColor7"
        x1={88.967}
        x2={-13.726}
        y1={142.518}
        y2={164.388}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#999" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);

export default BgBlurboxPattern;
